import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },

  header: {
    '&.MuiTypography-root': {
      fontSize: theme.spacing(2.25),
      padding: theme.spacing(1.25),
    },
  },

  description: {
    '&.MuiTypography-root': {
      color: theme.palette.text.disabled,
      fontSize: theme.spacing(1.75),
      marginBottom: theme.spacing(3.125),
    },
  },
}));
